import React, { } from 'react';
import { useSelector } from 'react-redux';
import { useTranslation } from "react-i18next";

import {
} from '@lockerpm/design';

import {
} from '@ant-design/icons'

import importExportComponents from '../../components/import-export';

import '../css/import-export-progress.scss';

function ImportExportProgress() {
  const { ImportProgress, ExportProgress } = importExportComponents;
  const { t } = useTranslation();

  const progressData = useSelector((state) => state.workspace.progressData);

  return (
    <div className="import-export-progress">
      {
        progressData.map((progress) => <div key={progress.id}>
          {
            progress.isExport && <ExportProgress
              progress={progress}
            />
          }
          {
            !progress.isExport && <ImportProgress
              progress={progress}
            />
          }
        </div>)
      }
    </div>
  );
}

export default ImportExportProgress;
